import { render, staticRenderFns } from "./gridCard.vue?vue&type=template&id=7902c5a9&scoped=true"
import script from "./gridCard.vue?vue&type=script&lang=js"
export * from "./gridCard.vue?vue&type=script&lang=js"
import style0 from "./gridCard.vue?vue&type=style&index=0&id=7902c5a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7902c5a9",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QImg,QCardSection,QScrollArea,QIcon});qInstall(component, 'directives', {Ripple});
